export default {
  tokenCentralBWName: 'integrationBWCentral',
  surrogateProvider: 'surrogate',
  casProviderKey: 'cas-provider',
  productKey: 'productId',
  productDataKey: 'productData'
}
